<template>
  <div class="tw-relative" v-if="email">
    <authorisation-wrapper
      :resource="EMAIL_SECURITY"
      :action="WRITE"
      v-slot="{ isAllowed }"
    >
      <iframe
        v-if="isAllowed"
        title="Highlighted Email"
        :srcdoc="email"
        class="tw-bg-white tw-text-primary-grey-800 tw-min-h-[70vh] tw-w-full tw-flex tw-justify-center tw-p-4 tw-border tw-border-primary-grey-100 tw-rounded-md tw-shadow-md"
        data-clarity-mask="true"
      ></iframe>
      <div v-else class="tw-w-full">
        <div>
          <div
            class="tw-absolute tw-top-1/2 tw-left-1/2 tw--translate-x-1/2 tw--translate-y-1/2 tw-z-10"
          >
            <cl-callout
              :close-text="$t('close')"
              :test-id="'incident-details-readonly-callout'"
              variant="info"
            >
              <template #title>
                {{ $t("restricted-view-title") }}
              </template>
              <template #message>
                {{ $t("restricted-view-banner") }}
              </template>
            </cl-callout>
          </div>
          <div>
            <iframe
              title="Highlighted Email"
              :srcdoc="email"
              class="tw-bg-white tw-text-primary-grey-800 tw-min-h-[70vh] tw-w-full tw-flex tw-justify-center tw-p-4 tw-border tw-border-primary-grey-100 tw-rounded-md tw-shadow-md tw-blur-sm"
            ></iframe>
          </div>
        </div>
      </div>
    </authorisation-wrapper>
  </div>
</template>

<script setup lang="ts">
import { EMAIL_SECURITY, WRITE } from "@/authorisation";
import { AuthorisationWrapper } from "@/authorisation";

type Props = {
  email: string;
};

defineProps<Props>();
</script>
